import _uniq from 'lodash/uniq';
import Promise from 'bluebird';

/**
 * This function fire offs redux actions when a route component is initially mounted or updated.  This generally retrieves
 * the initial data needed for the page.
 * @param {function} dispatch - Redux dispatch method to fire off actions
 * @param {array} components - The components initially rendered by the router.  Typically PageShell and a child component based
 * on the route (Home, Features, Schedule or Collection)
 * @param {object} [pathParams] - Optional path parameters extracted by react-router
 * @param {objeect} [query] - Optional url query parameters
 * @param {string} [lang] - Optional lang originating from client and passed into the PageAPI
 * @param {array} [actions] - Optional array of ancillary actions to be fired
 * @param {string} [preActions] - Optional array of actions that should occur before all other actions are fired
 */

export default (dispatch, components = [], pathParams = {}, query, lang, actions = [], preActions = []) => {
    let loadActions = components.reduce((prev, current) =>
        prev.concat((current && current.loadActions) || [])
    , actions);

    loadActions = _uniq(loadActions);

    const prePromises = preActions.map((preAction) => dispatch(preAction()));
    return Promise.all(prePromises).finally(() => {
        const promises = loadActions.map(action => dispatch(action(pathParams, query, lang)));
        return Promise.all(promises);
    });
};



// WEBPACK FOOTER //
// ./server/fetchComponentData.js